/**
 * /app/walls — list of saved wall designs.
 */

import { Frame } from 'lucide-react';
import { DesignsList } from '@/features/designs/DesignsList';

export function WallsIndexPage() {
  return (
    <DesignsList
      module="muros"
      description="Muros estructurales (placas) con P-M en plano, cortante E.060 11.10 y elementos de borde."
      icon={<Frame size={24} strokeWidth={1.5} />}
    />
  );
}
